import { requests } from "../../utils/api/api.service";
import { STATISTICS_URL } from "../../utils/api/endpoints";
import { IStatistics } from "../../shared/interfaces/statistics/IStatistics";

export const StatisticsService = {
  get: (): Promise<{ data: IStatistics }> => requests.get(STATISTICS_URL),
};
